import * as React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import * as Data from "src/Data";
import { Trad } from "src/components";

export const GetInvoicesListColumns = () => [
    {
        name: "ID_FatturaDatiEconomici",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Identificativo",
        label: Trad.Trad("Identificativo"),
        options: {
            filter: false
        }
    },
    {
        name: "DataRiferimentoDocumento",
        label: Trad.Trad("DataRiferimento"),
        options: {
            filter: false,
            customBodyRender: (val: Date | undefined) => Data.DataValoreTrad(val)
        }
    },
    {
        name: "Creato",
        label: Trad.Trad("DataUpload"),
        options: {
            filter: false,
            customBodyRender: (val: Date | undefined) => Data.DataValoreTrad(val)
        }
    },

    {
        name: "ID_FatturaDatiEconomici",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => (
                <a href={`/Contabilita/FattureDatiEconomici/${val}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </a>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/SearchTableColumns/InvoicesListColumns.tsx